module.exports = __webpack_public_path__ + "static/media/blueBell.e909291b.svg";